import { connect } from 'react-redux';
import TinyBusinessAnalytics from '../views/tiny/TinyBusinessAnalytics';

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch) => ({});

const TinyClubRakeContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyBusinessAnalytics);

export default TinyClubRakeContainer;


